import { Box, Tooltip, Theme, Popover, IconButton, Typography, InputBase, Chip, Button, } from "@mui/material";
import AttachmentIconnew from "../../assets/action-items/icon-attachment.svg";
import { ACTION_OPTIONS, DUE_DATE_FILTER_OPTIONS, getSubscriberOptions, getUniqueAccounts, getUniqueAssignees, getUniqueTags, isNewItem } from "../../utils/utils";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
import { useEffect, useState } from "react";
import ActionItemsStatusCell from "./ActionItemsStatusCell";
import DefaultFlag from "../../assets/action-items/default-flag.svg";
import EditIcon from "../../assets/common/edit-icon.svg";
import React from "react";
import ActionItemsAssigneeCell from "./ActionItemsAssigneeCell";
import "../../styles/actionItems.css"
import ActionItemsAiIcon from "../../assets/interaction-detail-page/actionitems_ai-icon.svg";
import SubscribedIcon from "../../assets/common/subscribedIcon.svg";
import ColumnFilter from "../Common/customFilter";
import ActionItemsAccountCell from "./ActionItemsAccountCell";
import MomLinkIcon from "../../assets/action-items/File-link-icon.svg";
import AddtaskPlusIcon from "../../assets/action-items/Action-item-plus-icon.svg";
import ManualIcon from "../../assets/action-items/manual-icon.svg";
import EnterIcon from "../../assets/common/enter-arrow-icon.svg";
import CancelIcon from "../../assets/common/discard_icon.svg";
import SubTaskIcon from "../../assets/action-items/sub-tasks-icon.svg";
import SubTaskCountIcon from "../../assets/action-items/SubtaskCountIcon.svg";

const initialSort = { sort_field: "dueDate", sort_order: "desc" as "asc" | "desc" };
const initialFilter = [
  {
    id: "status",
    value: ["To Do", "In Progress"],
  },
];
import {PRIORITY_OPTIONS, getStatusOptions} from "../../utils/utils";
import ActionItemsTagsCell from "./ActionItemsTagsCell";
import ActionItemsSubscribersCell from "./ActionItemSubscribersCell";
import CommonDatePicker from "../Common/CommonDatePicker";
import DescSortIcon from "../../assets/common/Desc-sort-icon.svg";
import AscSortIcon from "../../assets/common/Asc-sort-icon.svg";
import EllipsedTooltip from "../Common/EllipsedTooltip";
import SubscribersHoverPopperWrapper from "./subscribersHoverPopper";
import ApproveIcon from "../../assets/approve.svg";
import DiscardIcon from "../../assets/discard.svg";
import { resolveIsSubTaskFlag } from "../../utils/subtaskUtils";

const getSubtaskCount = (value: unknown): number => {
  if (Array.isArray(value)) return value.length;
  const count = Number(value);
  return Number.isFinite(count) ? count : 0;
};

const getColumns = (
  _isLargeUp: boolean,
  _theme: Theme,
  _attendees?: string[] | null,
  columnFilters?: any,
  updateColumnFilter?: (key: string, value: any) => void,
  dropdownUserData?: {
    usersList: any[];
    accountList: any[];
    tagsList: any[];
    spacesList: any[];
  },
  sort?: { sort_field: string; sort_order: "asc" | "desc" }, // New
  onSortChange?: (columnKey: string, direction: "asc" | "desc") => void,
  bulkUpdateValues?: Record<string, any> | undefined,
  selectedActionItemIds?: any[] | undefined,
  isReadOnly: boolean = false,
  rowAction?: any,
  openFilterColumnParam?: string | null,
  setOpenFilterColumnParam?: React.Dispatch<React.SetStateAction<string | null>>,
) => { 
  const optimisticStatusMap = new Map<string, "approved" | "discarded">();
  const uniqueAssignees = getUniqueAssignees(dropdownUserData).map((option) => ({
    ...option,
    type: "assignee" as const,
  }));
  const uniqueAccounts = getUniqueAccounts(dropdownUserData);
  const uniqueTags = getUniqueTags(dropdownUserData);
  const STATUS_OPTIONS = getStatusOptions();
  const subscriberOptions = getSubscriberOptions(dropdownUserData);
  const openFilterColumn = openFilterColumnParam ?? null;
  const setOpenFilterColumn = setOpenFilterColumnParam || (() => {});
  const isAssigneeActive = Array.isArray(columnFilters?.assignee) && columnFilters?.assignee.length > 0;
  const showActionsColumn = rowAction?.selectedTab === "aiRecommendedTasks";

  const columns = [
    {
      accessorKey: "serialnumber",
      header: "",
      Header: (
        <Box className="column-header"
        sx={{
            padding: "1px 0px",
          }}>
          <Typography className="cf-title">
            S. No. </Typography>
        </Box>
      ),
      size: 50,
      minSize: 50,
      grow: true,
      enableSorting: false,
      enableColumnFiltering: false,
      enableColumnOrdering: true,
      Cell: ({ row, table }: any) => {
        if (row.original?.isAddRow) return null;
        const { pageIndex, pageSize } = table.getState().pagination;
        const visibleRows = table
          .getRowModel()
          .rows
          .filter((r: any) => !r.original?.isAddRow);
        const visibleIndex = visibleRows.findIndex((r: any) => r.id === row.id);
        const displayIndex = visibleIndex !== -1 ? visibleIndex : row.index;
        return (
          <Box>
            {pageIndex * pageSize + displayIndex + 1}.
          </Box>
        );
      },
    },
    {
      accessorKey: "description",
      header: "",
      Header: (
            <Box className="column-header"
              sx={{
                padding: " 1px 10px",
                backgroundColor: openFilterColumn === "description" ? "#F2F2F2" : "inherit",
              }}>
            <Typography
                className="cf-title"
                sx={{
                  color:
                    columnFilters?.description
                      ? "#6036d6"
                      : "inherit",
                }}
              >
              Title </Typography>
            {sort?.sort_field === "description" && (
                <Box
                  className="cf-sort-click"
                  onClick={(e) => {
                    e.stopPropagation();
                    const newOrder =
                      sort.sort_order === "asc" ? "desc" : "asc";
                    onSortChange?.("description", newOrder);
                  }}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    marginLeft: "4px",
                  }}
                >
                  {sort.sort_order === "asc" ? (
                    <img src={AscSortIcon} className="cf-sort-icon-active" />
                  ) : (
                    <img src={DescSortIcon} className="cf-sort-icon-active" />
                  )}
                </Box>
              )}
          {isReadOnly ? null :(
            <ColumnFilter
              currentValue={columnFilters?.description ?? ""}
              onApply={(val) => updateColumnFilter?.("description", val)}
              options={[]}
              type="multi"
              showSections={{
                apply: false,
                options: false,
              }}
              columnKey="description" // Identify column
              sortDirection={
                sort?.sort_field === "description" ? sort.sort_order : null
              }
              onSortChange={onSortChange} // Sort callback
              placeHolder={"Search by Title"}
              onOpen={() => {rowAction?.onColumnFilterOpen?.(); setOpenFilterColumn("description")}}
              onClose={() => setOpenFilterColumn(null)}
              isActive={columnFilters?.description}
              parent_page="tasks_page"
              enableSearchMode={true}
            />
          )}
        </Box>
      ),
      Cell: ({ cell, row }: { cell: any; row: any }) => {
        // Special Add Task row
        if (row.original?.isAddRow) {
          return (
            <Box
              className="add-task-row flex h-full flex-row items-center pl-2 cursor-pointer"
              sx={{
                width: "100%",
                padding: "0px 4px",
              }}
              onClick={(e) => {
                e.stopPropagation();
                rowAction?.onAddTask?.(e.currentTarget.closest("tr"));
              }}
            >
              <span className="add-task-row-text flex items-center gap-1"> 
                <img src={AddtaskPlusIcon} alt="plus" className="add-task-plus-icon" />
                Add Task
              </span>
            </Box>
        );
      }
        const canEdit = row.original?.canEdit ?? false; 
        const isAiGenerated = row.original?.is_ai_generated;
        const isSystemGeneratedTask = row.original?.isSystemGeneratedTask;
        const subTaskCount = getSubtaskCount(row.original?.subtaskCount);
        const hasSubTasks = subTaskCount > 0;
        const isSubTask = resolveIsSubTaskFlag(row.original);
        const [hovered, setHovered] = useState(false);
        const [isEditing, setIsEditing] = useState(false);
        const [value, setValue] = useState(cell.getValue() as string);
        const isDiscarded = row.original?.isDiscarded ?? false;
        useEffect(() => {
            setValue(row.original.description ?? "");
        }, [row.original.description]);        
        const handleSave = () => {
          const trimmedValue = value.trim(); // trim whitespace
          if (!trimmedValue) return;
          setIsEditing(false);
          if (trimmedValue !== (cell.getValue() as string)) {
            rowAction.updateDescriptionCallBack?.(row, trimmedValue);
          }
          setValue(trimmedValue); // update the input value to trimmed
          setHovered(false);
        };
        const createdAt = row.original?.createdAt;
        const assigneeUpdatedAt= row.original?.assigneeUpdatedAt;
        const showNewTag = Boolean((createdAt && isNewItem(createdAt)) || (assigneeUpdatedAt && isNewItem(assigneeUpdatedAt)));

        const handleCancel = ()=> {
          setIsEditing(false);
          setValue(row.original.description ?? "");
        }

        const handleOpenSlideover = (e?: React.MouseEvent) => {
          if (e) e.stopPropagation();
          if (isEditing || isDiscarded) return;
          rowAction?.selectRowCallback?.(row, canEdit);
        };

        return (
          <Box
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            sx={{ 
              position: "relative", 
              width: "100%", 
              height: "100%",
              display: "flex",
              alignItems: "center",
              gap: "8px", 
              pointerEvents: isReadOnly ? "none" : "auto",
              cursor: isReadOnly ? "default" : "pointer",
            }}
          >
            <div className="action-item-icons">
              {isSubTask && (
                <img
                  src={SubTaskIcon}
                  alt="subtask"
                  className="action-item-subtask-icon"
                />
              )}
              {isAiGenerated || isSystemGeneratedTask ? (
                <img
                  src={ActionItemsAiIcon}
                  alt="AI"
                  className="action-item-source-icon"
                  style={{ maxWidth: "20px", minWidth: "20px", height: "15px" }}
                />
              ) : (
                <img 
                  src={ManualIcon}
                  alt="manual"
                  className="action-item-source-icon"
                  style={{ maxWidth: "20px", minWidth: "20px", height: "15px" }}
                />
              )}
            </div>
            {showNewTag && (
              <Box
                sx={{
                  backgroundColor: "#5731C3",
                  color: "#FFFFFF",
                  fontSize: "10px",
                  fontWeight: 600,
                  padding: "0px 6px",
                  borderRadius: "13px",
                }}
              >
                New
              </Box>
            )}

            <Box
              sx={{
                flex: 1,
                display: "flex",
                alignItems: "center",
                overflow: "hidden",
                paddingRight: canEdit ? "32px" : "8px",
                gap: "12px",
                cursor: isDiscarded ? "not-allowed":"pointer",
              }}
              onClick={handleOpenSlideover}
            >
              {canEdit && isEditing ? (
                <InputBase
                  value={value}
                  autoFocus
                  onChange={(e) => setValue(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && value.trim()) handleSave();
                  }}
                  onClick={(e) => e.stopPropagation()}
                  sx={{
                    fontSize: "13px",
                    width: "100%",
                    padding: "0px 0px 0px 2px",
                    borderRadius: "6px",
                    border: "1px solid #ccc",
                    backgroundColor: "#fff",
                    marginBottom: "0px",
                  }}
                />
              ) : (
                <EllipsedTooltip tooltipContent={value} className="hover-style" maxWidth="600px">
                  <span>
                    {value}
                  </span>
                </EllipsedTooltip>
              )}
              {hasSubTasks && (
                <Tooltip
                  title={`${subTaskCount} ${subTaskCount === 1 ? "Subtask" : "Subtasks"}`}
                  placement="top"
                  arrow
                  classes={{
                    tooltip: "subTask-count-tooltip",
                    arrow: "subTask-count-tooltip-arrow",
                  }}
                >
                  <Box
                    component="button"
                    type="button"
                    className="action-item-subtask-count"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleOpenSlideover(e);
                    }}
                  >
                    <img src={SubTaskCountIcon} alt="Subtasks" />
                    <span>{subTaskCount}</span>
                  </Box>
                </Tooltip>
              )}
              {row.original.attachments?.length > 0 && (
                <img src={AttachmentIconnew} alt="" width={16}/>
              )}
            </Box>
            {canEdit && !isEditing && (
              <Tooltip title="Edit" placement="top">
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsEditing(true);
                  }}
                  sx={{
                    position: "absolute",
                    right: 0,
                    height: "100%",
                    minHeight: "24px",
                    width: "28px",
                    opacity: hovered ? 1 : 0,
                    visibility: hovered ? "visible" : "hidden",
                    transition: "opacity 0.2s ease, visibility 0.2s ease",
                    borderRadius: "6px",
                    border: "1px solid #ccc",
                    padding: "0px",
                    marginBottom: "0px"
                  }}
                >
                  <img src={EditIcon} alt="Edit" width={14} height={14} />
                </IconButton>
              </Tooltip>
            )}
            {canEdit && isEditing && (
              <div style={{
                display: "flex",
                gap: "10px",
                alignItems: "center",
              }}>
                <Button
                  variant="contained"
                  size="small"
                  className="save-button"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSave();
                  }}
                  disabled={!value.trim() || value.trim() === (cell.getValue() as string)}
                >
                  Save
                  <img src={EnterIcon} alt="enter" className="enter-icon" />
                </Button>
                <Tooltip title="Cancel" placement="top" arrow>
                  <img src={CancelIcon} onClick={(e) => { e.stopPropagation(); handleCancel(); }} alt="" style={{width: "20px", height: "20px", marginTop: "2px"}}/>
                </Tooltip>
              </div>
            )}
          </Box>
        );
      },
      enableSorting: false,
      enableColumnFilter: true,
      enableColumnOrdering: true,
      grow: false,
      size: 450,
      minSize: 400,
      maxSize: 650,
    },
    {
      accessorKey: "momlink",
      header: "",
      Header: (
        <Box className="cf-container">
          <Box className="cf-label">
            <Typography className="cf-title" sx={{ marginTop: "2px", paddingLeft: "10px" }}>
              MoM Link
            </Typography>
          </Box>
        </Box>
      ),
      enableColumnFilter: false,
      enableSorting: false,
      enableColumnOrdering: true,
      grow: true,
      minSize: 100,
      size: 100,
      Cell: ({ row }: { row: any }) => {
        if (row.original?.isAddRow) return null;
        const attachments = row.original?.attachments || [];
      // Find the attachment where description is exactly "MOM"
      const momAttachment = attachments?.find(
        (att: any) => att.description?.toUpperCase() === "MOM"
      );

      if (!momAttachment || !momAttachment.url) {
        // No MoM link found — show dash
        return (
          <span className="flex items-center justify-center ml-4">-</span>
        );
      }
        const handleClick = () => {
          if(isReadOnly) return;
          window.open(momAttachment?.url, "_blank", "noopener,noreferrer");
        };
        return (
          <Box className="flex items-center justify-center ml-4 mom-link-box">
            <img
              src={MomLinkIcon}
              alt="Open Link"
              style={{
                width: 24,
                height: 24,
                cursor: isReadOnly ? "default" : "pointer",
                display: "block",
                margin: "auto",
              }}
              onClick={handleClick}
            />
          </Box>
        );
      },
    },
    {
      accessorKey: "assignee",
      header: "",
      Header: (
          <Box className="column-header"
            sx={{
              padding: " 1px",
              backgroundColor: openFilterColumn === "assignee" ? "#F2F2F2" : "inherit",
            }}>
            <Typography className="cf-title"
              sx={{
                color:
                  Array.isArray(columnFilters?.assignee) &&
                  columnFilters?.assignee.length > 0
                    ? "#6036d6"
                    : "inherit",
              }}>Solo Player
            </Typography>

        {isReadOnly ? null :(
        <ColumnFilter
          currentValue={columnFilters?.assignee ?? []}
          onApply={(val) => updateColumnFilter?.("assignee", val)}
          options={uniqueAssignees}
          type="multi"
          showSections={{
            search: true,
            sort: false,
          }}
          columnKey="assignee"
          onOpen={() => {rowAction?.onColumnFilterOpen?.(); setOpenFilterColumn("assignee")}}
          onClose={() => setOpenFilterColumn(null)}
          isActive={isAssigneeActive}
          parent_page="tasks_page"
          />
        )}
        </Box>
      ),
      Cell: ({ cell, row }: { cell: any; row: any }) => {
        if (row.original?.isAddRow) return null;
        const isSelected = selectedActionItemIds?.includes(row.original.id);
        const bulkAssignee = isSelected ? bulkUpdateValues?.soloPlayer : null;
        const highlightedCells = rowAction?.highlightedCells;
        const rowId = row.original?.id || row.id;

        const assigneeName = bulkAssignee?.label || row.original?.assignee_name;
        const profileOrgId = bulkAssignee?.value || cell.getValue();
        const assigneePictureUrl = row.original?.assigneePictureUrl;
        const assigneeEmail = row.original?.assigneeEmail;
        const canEdit = row.original?.canEdit ?? false;
        const activeUsers = row.original?.activeUsers || [];

        // find assignee participant details
        const assigneeParticipant = activeUsers.find(
          (user: any) => user.profileOrgRelationshipId === profileOrgId
        ) || {
          name: assigneeName || "",
          assigneeEmail,
          pictureUrl: assigneePictureUrl,
        };

        return (
          <ActionItemsAssigneeCell
            email={profileOrgId}
            name={assigneeName}
            participant={assigneeParticipant}
            attendeeParticipants={activeUsers}
            canEdit={ isReadOnly ? false : canEdit}
            row={row}
            rowAction={rowAction}
            onUpdate={rowAction.updateAssigneeCallback}
            highlightedCell={highlightedCells?.[rowId]?.assignee}
            autoOpenAssigneeDropdown={highlightedCells?.[rowId]?.open_assignee}
            removeHighlight={() => rowAction?.removeHighlight?.(rowId, "assignee")}
          />
        );
      },
      muiTableBodyCellProps: () => ({
        className: "assignee-table-cell",
      }),
      enableColumnFilter: false,
      enableSorting: false,
      enableColumnOrdering: true,
      grow: true,
      minSize: 120,
      size: 120,
    },
    {
      accessorKey: "tags",
      header: "",
      Header: (
        <Box className="column-header"
          sx={{
            padding: "1px",
            backgroundColor: openFilterColumn === "tags" ? "#F2F2F2" : "inherit",
          }}>
            <Typography
              className="cf-title"
              sx={{
                color:
                  Array.isArray(columnFilters?.tags) &&
                  columnFilters?.tags.length > 0
                    ? "#6036d6"
                    : "inherit",  
              }}
            >
              Tag
            </Typography>
        { isReadOnly ? null :(
            <ColumnFilter
              currentValue={columnFilters?.tags ?? []}
              onApply={(val) => {
                if(isReadOnly) return;
                updateColumnFilter?.("tags", val)}}
                options={uniqueTags}
                type="multi"
                showSections={{
                  search: true,
                  sort: false,
                }}
                columnKey = "tags"
                onOpen={() => {rowAction?.onColumnFilterOpen?.(); setOpenFilterColumn("tags")}}
                onClose={() => setOpenFilterColumn(null)}
                parent_page="tasks_page"
                />
          )}
          </Box>
      ),      
      enableColumnFilter: false,
      enableSorting: false,
      enableColumnOrdering: true,
      size: 110,
      minSize: 110,
      grow: true,
      Cell: ({ row }: { row: any }) => {
        if (row.original?.isAddRow) return null;
        const canEdit = row.original?.canEdit ?? false;
        const availableTags = row.original?.tagsList;
        const value =
          row.original.tags?.map((t: any) => ({
            tagId: t.id,
            tagName: t.name,
          })) || [];
          const isSelected = selectedActionItemIds?.includes(row.original.id);
           // Get bulk update tags (from bulkUpdateValues.tags)
            // bulkUpdateValues.tags = array of { label, value }
            const bulkTags = isSelected ? bulkUpdateValues?.tags : null;
            // If bulkTags present, transform into the same format your component expects
            const appliedTags = bulkTags
              ? bulkTags?.map((t: any) => ({
                  tagId: t.value,
                  tagName: t.label,
                }))
              : value;

        const handleTagChange = (_updatedTags: string[]) => {
        };
        const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
        const [isTagDropdownOpen, setIsTagDropdownOpen] = useState(false);
        useEffect(() => {
          if (isTagDropdownOpen) {
            setAnchorEl(null); // close hover popper when dropdown opens
          }
        }, [isTagDropdownOpen]);

        const handleMouseEnter = (event: React.MouseEvent<HTMLElement>) => {
          if (value.length > 1 && !isTagDropdownOpen) {
            setAnchorEl(event.currentTarget);
          }
        };

        const handleMouseLeave = () => setAnchorEl(null);
        const open = Boolean(anchorEl);

        return (
          <>
            <Box
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <ActionItemsTagsCell
                value={appliedTags}
                tagsList={availableTags}
                canEdit={ isReadOnly ? false : canEdit}
                onChange={handleTagChange}
                row={row}
                rowAction={rowAction}
                onOpen={() => setIsTagDropdownOpen(true)}
                onClose={() => setIsTagDropdownOpen(false)}
              />
            </Box>

            <Popover
              open={open}
              anchorEl={anchorEl}
              onClose={handleMouseLeave}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              PaperProps={{
                sx: {
                  p: 2,
                  borderRadius: "6px",
                  backgroundColor: "#fff",
                },
              }}
              container={document.body}
              disableRestoreFocus
              sx={{ pointerEvents: "none" }} // ensures hover only
            >
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "10px",
                  maxWidth: 170,
                }}
              >
                {value.map((tag: any) => (
                  <Chip
                    key={tag.tagId}
                    label={tag.tagName}
                    size="small"
                    className="tags-chip-hover"
                  />
                ))}
              </Box>
            </Popover>
          </>
        );
      },
      muiTableBodyCellProps: () => ({
        className: "assignee-table-cell",
      }),
    },
    {
      accessorKey: "account",
      header: "",
      Header: (
        <Box className="column-header"
          sx={{
              padding: " 1px",
              backgroundColor: openFilterColumn === "account" ? "#F2F2F2" : "inherit",
            }}>
            <Typography className="cf-title" 
            sx={{
              color:
                Array.isArray(columnFilters?.account) &&
                columnFilters?.account.length > 0
                  ? "#6036d6"
                  : "inherit",
            }}
            >Account</Typography>

        {isReadOnly ? null :(
        <ColumnFilter
          currentValue={columnFilters?.account ?? []}
          onApply={(val) => updateColumnFilter?.("account", val)}
          options={uniqueAccounts}
          type="multi"
          showSections={{
            search: true,
            sort: false,
          }}
          columnKey="account"
          onOpen={() => {rowAction?.onColumnFilterOpen?.(); setOpenFilterColumn("account")}}
          onClose={() => setOpenFilterColumn(null)}
          isActive={Array.isArray(columnFilters?.account) &&
                columnFilters?.account.length > 0}
          parent_page="tasks_page"
          />
        )}
        </Box>
      ),
      Cell: ({ row }: { row: any }) => {
        if (row.original?.isAddRow) return null;
        const rawValue = row.original?.clientName;
        const clientList = row.original?.clientList;
        const canEdit = row.original?.canEdit ?? false;
        const isSelected = selectedActionItemIds?.includes(row.original.id);
        const bulkAccount = isSelected ? bulkUpdateValues?.account : null;
        const appliedAccount = bulkAccount?.label || rawValue;
        return (
          <ActionItemsAccountCell
            clientName={appliedAccount}
            canEdit={ isReadOnly ? false : canEdit}
            row={row}
            rowAction={rowAction}
            clientList={clientList}
            showCrossIcon={true}
          />
        );
      },
      muiTableBodyCellProps: () => ({
        className: "assignee-table-cell",
      }),
      enableColumnFilter: false,
      enableSorting: false,
      enableColumnOrdering: true,
      grow: true,
      minSize: 110,
      size: 110,
    }, 
    {
      accessorKey: "coach",
      header: "",
      Header: (
        <Box className="column-header"
          sx={{
              padding: " 1px",
              backgroundColor: openFilterColumn === "coach" ? "#F2F2F2" : "inherit",
            }}>
            <Typography className="cf-title"
              sx={{
                color:
                  Array.isArray(columnFilters?.coach) &&
                  columnFilters?.coach.length > 0
                    ? "#6036d6"
                    : "inherit",
              }}>Solo Coach
            </Typography>

        {isReadOnly ? null :(
        <ColumnFilter
          currentValue={columnFilters?.coach ?? []}
          onApply={(val) => updateColumnFilter?.("coach", val)}
          options={uniqueAssignees}
          type="multi"
          showSections={{
            search: true,
            sort: false,
          }}
          columnKey="coach"
          onOpen={() => {rowAction?.onColumnFilterOpen?.(); setOpenFilterColumn("coach")}}
          onClose={() => setOpenFilterColumn(null)}
          isActive={Array.isArray(columnFilters?.coach) &&
                  columnFilters?.coach.length > 0}
          parent_page="tasks_page"
          />
        )}
        </Box>
      ),
      Cell: ({ cell, row }: { cell: any; row: any }) => {
        if (row.original?.isAddRow) return null;
        const email = cell.getValue() as string;
        const isSelected = selectedActionItemIds?.includes(row.original.id);
        const bulkCoach = isSelected ? bulkUpdateValues?.soloCoach : null;
        const profileOrgId = bulkCoach?.value || email;
        const coachName = bulkCoach?.label || row.original?.coachName;
        const coachEmail = row.original?.coachEmail;
        const coachPictureUrl = row.original?.coachPictureUrl;
        const canEdit = row.original?.canEdit ?? false;
        const activeUsers = row.original?.activeUsers || [];
        const coachParticipant = activeUsers.find(
          (user: any) => user.profileOrgRelationshipId === profileOrgId
        ) || {
          name: coachName || "",
          email: coachEmail,
          pictureUrl: coachPictureUrl,
        };

        return (
          <ActionItemsAssigneeCell
            email={profileOrgId}
            name={coachName}
            participant={coachParticipant}
            attendeeParticipants={activeUsers}
            canEdit={ isReadOnly ? false : canEdit}
            row={row}
            rowAction={rowAction}
            fieldName="coach"
            onUpdate={(row, email, removeField) => {
              if (email === null && removeField) {
                rowAction.updateCoachCallback(row, null, removeField);
              } else {
                rowAction.updateCoachCallback(row, email);
              }
            }}
            showCrossIcon={true}
          />
        );
      },
      muiTableBodyCellProps: () => ({
        className: "assignee-table-cell",
      }),
      enableColumnFilter: false,
      enableSorting: false,
      enableColumnOrdering: true,
      grow: true,
      minSize: 120,
      size: 130,
    },
    {
      accessorKey: "sponsor",
      header: "",
      Header: (
          <Box className="column-header"
          sx={{
              padding: " 1px",
              backgroundColor: openFilterColumn === "sponsor" ? "#F2F2F2" : "inherit",
            }}>
            <Typography className="cf-title"
              sx={{
                  color:
                    Array.isArray(columnFilters?.sponsor) &&
                    columnFilters?.sponsor.length > 0
                      ? "#6036d6"
                      : "inherit",
                }}
            >Exec Sponsor</Typography>

          {isReadOnly ? null :(
            <ColumnFilter
              currentValue={columnFilters?.sponsor ?? []}
              onApply={(val) => updateColumnFilter?.("sponsor", val)}
              options={uniqueAssignees}
              type="multi"
              showSections={{
                search: true,
                sort: false,
              }}
              columnKey="sponsor"
              onOpen={() => {rowAction?.onColumnFilterOpen?.(); setOpenFilterColumn("sponsor")}}
              onClose={() => setOpenFilterColumn(null)}
              isActive={Array.isArray(columnFilters?.sponsor) &&
                    columnFilters?.sponsor.length > 0}
              parent_page="tasks_page"
            />
          )}
          </Box>
      ),
      Cell: ({ cell, row }: { cell: any; row: any }) => {
        if (row.original?.isAddRow) return null;
        const email = cell?.getValue() as string;
        const canEdit = row.original?.canEdit ?? false;
        const activeUsers = row.original?.activeUsers || [];

        const isSelected = selectedActionItemIds?.includes(row.original.id);
        const bulkSponsor = isSelected ? bulkUpdateValues?.execSponsor : null;

        const sponsorEmail = bulkSponsor?.value || email;
        const sponsorName = bulkSponsor?.label || row.original?.sponsor;

        const sponsorParticipant =
          activeUsers.find((user: any) => user.profileOrgRelationshipId === sponsorEmail) || {
            name: sponsorName || "",
            email: sponsorEmail,
            pictureUrl: null,
          };
        return (
          <ActionItemsAssigneeCell
            email={sponsorEmail}
            name={sponsorName}
            participant={sponsorParticipant}
            attendeeParticipants={activeUsers}
            canEdit={ isReadOnly ? false : canEdit}
            row={row}
            rowAction={rowAction}
            fieldName="sponsor"
            onUpdate={(row, email, removeField) => {
              if (email === null && removeField) {
                rowAction.updateSponsorCallback(row, null, removeField);
              } else {
                rowAction.updateSponsorCallback(row, email);
              }
            }}
            showCrossIcon={true}
          />
        );
      },
      muiTableBodyCellProps: () => ({
        className: "assignee-table-cell",
      }),
      enableColumnFilter: false,
      enableSorting: false,
      enableColumnOrdering: true,
      grow: true,
      minSize: 140,
      size: 150,
    },
    {
      accessorKey: "createdAt",
      header: "",
      Header: (
          <Box className="column-header"
          sx={{
              padding: " 1px",
              backgroundColor: openFilterColumn === "createdAt" ? "#F2F2F2" : "inherit",
            }}>
            <Typography className="cf-title" 
            sx={{
              color:
                Array.isArray(columnFilters?.createdAt) &&
                columnFilters?.createdAt.length > 0
                  ? "#6036d6"
                  : "inherit",
            }}
            >Created At</Typography>
            {sort?.sort_field === "createdAt" && (
              <Box
                className="cf-sort-click"
                onClick={(e) => {
                  e.stopPropagation();
                  const newOrder =
                    sort.sort_order === "asc" ? "desc" : "asc";
                  onSortChange?.("createdAt", newOrder);
                }}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  marginLeft: "4px",
                }}
              >
                {sort.sort_order === "asc" ? (
                  <img src={AscSortIcon} className="cf-sort-icon-active"
                    />
                  ) : (
                    <img src={DescSortIcon} className="cf-sort-icon-active"
                    />
                  )}
              </Box>
            )}

          {isReadOnly ? null :(
            <ColumnFilter
              currentValue=""
              onApply={(val) => {
                return val;
              }}
              options={[]}
              showSections={{
                sort: true,
                search: false,
                options: false,
                apply: false,
              }}
              onOpen={() => {rowAction?.onColumnFilterOpen?.(); setOpenFilterColumn("createdAt")}}
              type="single"
              columnKey="createdAt" // Pass column identifier
              sortDirection={
                sort?.sort_field === "createdAt"
                  ? (sort.sort_order as "asc" | "desc")
                  : null
              }
              onSortChange={onSortChange} // Pass sort callback
              onClose={() => setOpenFilterColumn(null)}
              isActive={sort?.sort_field === "createdAt"}
              parent_page="tasks_page"
            />
            )}
          </Box>
      ),
      enableSorting: false,
      enableColumnFilter: false,
      enableColumnOrdering: true,
      grow: true,
      minSize: 140,
      size: 150,
      Cell: ({ row }: { cell: any; row: any }) => {
        if (row.original?.isAddRow) return null;
        const createdAt = row?.original?.createdAt;
        const createdAtDate = createdAt ? dayjs(createdAt) : null;
        const displayDate = createdAtDate?.isValid()
          ? createdAtDate.format("MMM DD, YYYY")
          : "-";
        const displayColor = "#43434D";
        return (
          <Box
            className="due-date-cell-wrapper"
            sx={{
              width: "100%",
              cursor: "not-allowed",
            }}
          >
            <span style={{ cursor: "pointer", color: displayColor }}>
              {displayDate}
            </span>
          </Box>
        );
      }
    },
    {
      accessorKey: "dueDate",
      header: "",
      Header: (
          <Box className="column-header"
            sx={{
            padding: " 1px",
            backgroundColor: openFilterColumn === "dueDate" ? "#F2F2F2" : "inherit",
          }}>
            <Typography 
            className="cf-title" 
            sx={{
              color:
                Array.isArray(columnFilters?.dueDate) &&
                columnFilters?.dueDate?.includes("overdue")
                  ? "#6036d6"
                  : "inherit",
            }}
            >Due date
            </Typography>
            {sort?.sort_field === "dueDate" && (
              <Box
                className="cf-sort-click"
                onClick={(e) => {
                  e.stopPropagation();
                  const newOrder =
                    sort.sort_order === "asc" ? "desc" : "asc";
                  onSortChange?.("dueDate", newOrder);
                }}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  marginLeft: "4px",
                }}
              >
                {sort.sort_order === "asc" ? (
                  <img src={AscSortIcon} className="cf-sort-icon-active"
                    />
                  ) : (
                    <img src={DescSortIcon} className="cf-sort-icon-active"
                    />
                  )}
              </Box>
            )}
          {isReadOnly ? null :(
            <ColumnFilter
              currentValue={columnFilters?.dueDate ?? ""}
              onApply={(val) => {
                if (!Array.isArray(val)) return;
                updateColumnFilter?.("dueDate", val);
              }}
              options={DUE_DATE_FILTER_OPTIONS}
              showSections={{
                sort: true,
                search: false,
                apply: true,
                options: true,
              }}
              onOpen={() => {rowAction?.onColumnFilterOpen?.(); setOpenFilterColumn("dueDate")}}
              type="multi"
              columnKey="dueDate" // Pass column identifier
              sortDirection={
                sort?.sort_field === "dueDate"
                  ? (sort.sort_order as "asc" | "desc")
                  : null
              }
              onSortChange={onSortChange} // Pass sort callback
              onClose={() => setOpenFilterColumn(null)}
              isActive={Array.isArray(columnFilters?.dueDate) &&
                columnFilters?.dueDate?.includes("overdue")}
              parent_page="tasks_page"
            />
          )}
          </Box>
      ),
      filterVariant: "date",
      filterFn: "lessThan",
      sortingFn: "datetime",
      enableSorting: false,
      Cell: ({ cell, row }: { cell: any; row: any }) => {
        if (row.original?.isAddRow) return null;
        const rawValue = cell.getValue();
        const isSelected = selectedActionItemIds?.includes(row.original.id);
        const [isDatePickerOpen, setDatePickerOpen] = useState(false);
        const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
        const cellRef = React.useRef<HTMLDivElement | null>(null);
        const highlightedCells = rowAction?.highlightedCells;
        const rowId = row.original?.id || row.id;
        const date = row?.original?.date;
        const bulkDueDate = bulkUpdateValues?.dueDate?.value || null;
        // Determine final date value
          const effectiveDate = isSelected && bulkDueDate ? bulkDueDate : rawValue || date;
          const effectiveDay = effectiveDate
            ? dayjs(effectiveDate).utc(true)
            : null;
        const displayDate = effectiveDay ? effectiveDay.format("MMM DD, YYYY")  : "-";
        const isOverdue = effectiveDay?.isBefore(dayjs(), "day");
        const displayColor = 
        isSelected && bulkDueDate ? "#43434D" : isOverdue ? "red" : "#43434D";
        const canEdit = row.original?.canEdit ?? false;
        const canEditDueDate = !isReadOnly && canEdit;
        const handleDateClick = (e: React.MouseEvent<HTMLElement>) => {
          if (!canEditDueDate) return;
            setAnchorEl(e.currentTarget);
            setDatePickerOpen(true);
        };

        const handleDateChange = (newValue: string | null) => {
          if (!canEditDueDate) return;
          const formatted = newValue ? (dayjs(newValue).isValid() ? dayjs(newValue).format("YYYY-MM-DD") : newValue) : newValue;
          rowAction.updateDueDateCallback(row, formatted);
          setTimeout(() => {
            handleClose();
          }, 0);
        };

        const handleClose = () => {
          setDatePickerOpen(false);
          setAnchorEl(null);
          rowAction?.removeHighlight?.(rowId, "dueDate");
        };

        useEffect(() => {
          if (!rowAction?.openTaskDialog || !isDatePickerOpen) return;
          setDatePickerOpen(false);
          setAnchorEl(null);
        }, [rowAction?.openTaskDialog]);

        const setCellRef = (node: HTMLDivElement | null) => {
          cellRef.current = node;

          if (
            node &&
            highlightedCells?.[rowId]?.autoOpenDueDatePicker &&
            canEditDueDate &&
            !isDatePickerOpen
          ) {
            setAnchorEl(node);
            setDatePickerOpen(true);
          }
        };

        return (
          <Box
            ref={setCellRef}
            className={`due-date-cell-wrapper ${
              isDatePickerOpen ? "due-date-cell-wrapper--active" : ""
            } ${highlightedCells?.[rowId]?.dueDate ? "error-border" : ""} ${
              !canEditDueDate ? "no-hover" : ""
            }`}
            onClick={handleDateClick}
            sx={{
              width: "100%",
              cursor: canEditDueDate ? "pointer" : "not-allowed",
            }}
          >
            <span style={{ cursor: "pointer", color: displayColor }}>
              {displayDate}
            </span>

            {isDatePickerOpen && (
              <CommonDatePicker
                value={effectiveDate}
                onChange={handleDateChange}
                onClose={handleClose}
                anchorEl={anchorEl}
                minDate={dayjs().subtract(1, "year").toISOString()} // optional bounds
                saveAsDateOnly={true}
              />
            )}
          </Box>
        );
      },
      enableColumnFilter: false,
      enableColumnOrdering: true,
      grow: true,
      minSize: 120,
      size: 130,
    },
    {
      accessorKey: "actions",
      header: "",
      Header: (
          <Box className="column-header"
              sx={{
              padding: "1px",
              backgroundColor: openFilterColumn === "actions" ? "#F2F2F2" : "inherit",
            }}
            >
              <Typography
                className="cf-title"
                sx={{
                  color:
                    Array.isArray(columnFilters?.actions) &&
                    columnFilters.actions.length > 0
                      ? "#6036d6"
                      : "inherit",
                  paddingLeft: "2px"
                }}
              >
                Actions
              </Typography>
              {sort?.sort_field === "aiActionItemState" && (
              <Box
                className="cf-sort-click"
                onClick={(e) => {
                  e.stopPropagation();
                  const newOrder =
                    sort.sort_order === "asc" ? "desc" : "asc";
                  onSortChange?.("aiActionItemState", newOrder);
                }}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  marginLeft: "4px",
                }}
              >
                {sort.sort_order === "asc" ? (
                  <img src={AscSortIcon} className="cf-sort-icon-active"
                    />
                  ) : (
                    <img src={DescSortIcon} className="cf-sort-icon-active"
                    />
                )}
              </Box>
            )}
        {isReadOnly ? null :(
        <ColumnFilter
          currentValue={columnFilters?.actions ?? []}
          onApply={(val) => updateColumnFilter?.("actions", val)}
          options={ACTION_OPTIONS}
          type="multi"
          showSections={{
            apply: rowAction?.selectedTab !== "aiRecommendedTasks" ? false : true,
            options: rowAction?.selectedTab !== "aiRecommendedTasks" ? false : true,
            search: false,
          }}
          columnKey="actions"
          sortDirection={
            sort?.sort_field === "aiActionItemState" ? sort.sort_order : null
          }
          onSortChange={(key, dir) => onSortChange?.(key === "actions" ? "aiActionItemState" : key, dir)}
          onOpen={() => {rowAction?.onColumnFilterOpen?.(); setOpenFilterColumn("actions")}}
          onClose={() => setOpenFilterColumn(null)}
          isActive={Array.isArray(columnFilters?.actions) &&
                    columnFilters.actions.length > 0}
          parent_page="tasks_page"
          />
        )}
        </Box>
      ),
      enableSorting: false,
      enableColumnFilter: false,
      enableColumnOrdering: true,
      grow: true,
      minSize: 150,
      size: 150,
      muiTableBodyCellProps: () => ({ sx: { overflow: "visible" } }),
      Cell: ({ row }: { cell: any; row: any }) => {
        if (row.original?.isAddRow) return null;
        const canEdit = row.original?.canEdit ?? false;
        const rowId = row.original?.id || row.id;
        const optimisticStatus = optimisticStatusMap.get(rowId) || null;
        const isApproved =
          optimisticStatus === "approved" || row.original?.isApproved;
        const isDiscarded =
          optimisticStatus === "discarded" || row.original?.isDiscarded;
        const isAiGenerated =
          row.original?.isAiGenerated ?? row.original?.is_ai_generated;

        const handleApproveClick = async () => {
          const assignee = row.original?.assignee;
          const dueDate = row.original?.dueDate;

          if (!assignee || !dueDate) {
            rowAction?.highlightMissingFields?.(row, {
              assignee: !assignee,
              open_assignee: !assignee,
              dueDate: !dueDate,
              autoOpenDueDatePicker: !dueDate && assignee,
            });
            rowAction?.showSnackbar?.(
              "warning",
              "Please fill the missing fields to proceed with approval."
            );
            return;
          }

          optimisticStatusMap.set(rowId, "approved");
          const apiResult = await rowAction?.acceptCallback?.(row);
          if (apiResult?.status && apiResult.status !== "approved") {
            optimisticStatusMap.delete(rowId);
          }
        };

        const handleDiscardClick = async () => {
          optimisticStatusMap.set(rowId, "discarded");
          const apiResult = await rowAction?.discardCallback?.(row);
          if (apiResult?.status && apiResult.status !== "discarded") {
            optimisticStatusMap.delete(rowId);
          }
        };

        if (isAiGenerated === false) {
          return (
            <Box className="accept-discard-status-box manual-box">
              <h1 className="base-text-status">Manual</h1>
            </Box>
          );
        }

        if (isApproved) {
          return (
            <Box className="accept-discard-status-box approve-box">
              <h1 className="base-text-status approve">Accepted</h1>
            </Box>
          );
        }

        if (isDiscarded) {
          return (
            <Box className="accept-discard-status-box discard-box">
              <h1 className="base-text-status discard">Discarded</h1>
            </Box>
          );
        }

        if (resolveIsSubTaskFlag(row.original)) {
          return null;
        }

        return (
          <Box className="accept-discard-buttons-box">
            <Tooltip title="Accept" placement="top" arrow>
              <span>
                <IconButton
                  size="small"
                  disabled={!canEdit}
                  onClick={handleApproveClick}
                  className="approve-btn"
                >
                  <img
                    src={ApproveIcon}
                    alt="Approve"
                    className="approve-icon"
                    style={{ opacity: canEdit ? 1 : 0.5 }}
                  />
                </IconButton>
              </span>
            </Tooltip>

            <Tooltip title="Discard" placement="top" arrow>
              <span>
                <IconButton
                  size="small"
                  disabled={!canEdit}
                  onClick={handleDiscardClick}
                  className="discard-btn"
                >
                  <img
                    src={DiscardIcon}
                    alt="Discard"
                    className="discard-icon"
                    style={{ opacity: canEdit ? 1 : 0.5 }}
                  />
                </IconButton>
              </span>
            </Tooltip>
          </Box>
        );
      }
    },
    {
      accessorKey: "priority",
      header: "",
      Header:(
            <Box className="column-header"
              sx={{
              padding: " 1px",
              backgroundColor: openFilterColumn === "priority" ? "#F2F2F2" : "inherit",
            }}
            >
              <Typography
                className="cf-title"
                sx={{
                  color:
                    Array.isArray(columnFilters?.priority) &&
                    columnFilters.priority.length > 0
                      ? "#6036d6"
                      : "inherit",
                  paddingLeft: "2px"
                }}
              >
                Priority
              </Typography>
              {sort?.sort_field === "priority" && (
              <Box
                className="cf-sort-click"
                onClick={(e) => {
                  e.stopPropagation();
                  const newOrder =
                    sort.sort_order === "asc" ? "desc" : "asc";
                  onSortChange?.("priority", newOrder);
                }}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  marginLeft: "4px",
                }}
              >
                {sort.sort_order === "asc" ? (
                  <img src={AscSortIcon} className="cf-sort-icon-active"
                    />
                  ) : (
                    <img src={DescSortIcon} className="cf-sort-icon-active"
                    />
                )}
              </Box>
            )}
        {isReadOnly ? null :(
        <ColumnFilter
          currentValue={columnFilters?.priority ?? ""}
          onApply={(val) => updateColumnFilter?.("priority", val)}
          options={PRIORITY_OPTIONS}
          type="multi"
          showSections={{
            search: false,
          }}
          columnKey="priority" // Identify column
          sortDirection={
            sort?.sort_field === "priority" ? sort.sort_order : null
          }
          onSortChange={onSortChange}
          onOpen={() => {rowAction?.onColumnFilterOpen?.(); setOpenFilterColumn("priority")}}
          onClose={() => setOpenFilterColumn(null)}
          isActive={Array.isArray(columnFilters?.priority) &&
                    columnFilters.priority.length > 0}
          parent_page="tasks_page"
          />
        )}
        </Box>
      ),
      Cell: ({ cell, row }: { cell: any; row: any }) => {
        if (row.original?.isAddRow) return null;
        const canEdit = row.original?.canEdit ?? false;
        const isSelected = selectedActionItemIds?.includes(row.original.id);
        const bulkPriority = isSelected ? bulkUpdateValues?.priority : null;

        // --- derive final display values ---
        const rawValues = bulkPriority?.value || cell.row.original.priority || "";
        const values: string[] = Array.isArray(rawValues)
        ? rawValues
        : rawValues.split(",").filter(Boolean);

        const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(
          null
        );
        const open = Boolean(anchorEl);

        const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
          if (canEdit) {
            setAnchorEl(event.currentTarget);
          }
        };

        const handleClose = () => {
          setAnchorEl(null);
        };

        return (
          <>
            <Box
              onClick={handleOpen}
              className={`priority-cell-wrapper ${
                open ? "priority-cell-wrapper--active" : ""
              } ${!canEdit ? "no-hover" : ""}`}
              sx={{
                pointerEvents: isReadOnly ? "none" : "auto",
              }}
            >
              {values.length ? (
                values.map((val) => {
                  const selectedOption =
                    PRIORITY_OPTIONS.find((opt) => opt.value === val) ||
                    PRIORITY_OPTIONS.find((opt) => opt.label === val);
                  return (
                    <Box key={val} className="priority-cell">
                      <img
                        src={selectedOption?.icon}
                        alt={selectedOption?.label}
                      />
                      <span>{selectedOption?.label}</span>
                    </Box>
                  );
                })
              ) : (
                <img
                  src={DefaultFlag}
                  alt="Default"
                  className="priority-cell__icon"
                />
              )}
            </Box>

            {canEdit && !isReadOnly && (
              <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
              >
                <Box className="priority-popover">
                  {PRIORITY_OPTIONS.map((item, idx) => (
                    <Box
                      key={idx}
                      className="priority-popover__option"
                      onClick={() => {
                        if(isReadOnly) return;
                        const selectedValue = item.value;
                        // Update local row data as a single string
                        cell.row.original.priority = selectedValue;
                        // Send only the string to the callback
                        rowAction.updatePriorityCallback(cell.row, selectedValue);
                        handleClose();
                      }}
                    >
                      <img
                        src={item.icon}
                        alt={item.label}
                        className="priority-cell__icon"
                      />
                      <span>{item.label}</span>
                    </Box>
                  ))}
                </Box>
              </Popover>
            )}
          </>
        );
      },
      enableColumnFilter: false,
      enableSorting: false,
      enableColumnOrdering: true,
      grow: true,
      minSize: 110,
      size: 110,
    },    
    {
      accessorKey: "status",
      header: "",
      Header: (
            <Box className="column-header"
              sx={{
              padding: " 1px",
              backgroundColor: openFilterColumn === "status" ? "#F2F2F2" : "inherit",
            }}
            >
              <Typography
                className="cf-title"
                sx={{
                  color:
                    Array.isArray(columnFilters?.status) &&
                    columnFilters.status.length > 0
                      ? "#6036d6"
                      : "inherit",
                }}
              >
                Status
              </Typography>
              {sort?.sort_field === "status" && (
              <Box
                className="cf-sort-click"
                onClick={(e) => {
                  e.stopPropagation();
                  const newOrder =
                    sort.sort_order === "asc" ? "desc" : "asc";
                  onSortChange?.("status", newOrder);
                }}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  marginLeft: "4px",
                }}
              >
                {sort.sort_order === "asc" ? (
                 <img src={AscSortIcon} className="cf-sort-icon-active"
                    />
                  ) : (
                    <img src={DescSortIcon} className="cf-sort-icon-active"
                    />
                )}
              </Box>
            )}
        {isReadOnly ? null :(
        <ColumnFilter
          currentValue={columnFilters?.status ?? []}
          onApply={(val) => updateColumnFilter?.("status", val)}
          options={STATUS_OPTIONS}
          type="multi"
          showSections={{
            search: false,
          }}
          columnKey="status" // Identify column
          sortDirection={
            sort?.sort_field === "status" ? sort.sort_order : null
          }
          onSortChange={onSortChange}
          onOpen={() => {rowAction?.onColumnFilterOpen?.(); setOpenFilterColumn("status")}}
          onClose={() => setOpenFilterColumn(null)}
          isActive={Array.isArray(columnFilters?.status) &&
                    columnFilters.status.length > 0}
          parent_page="tasks_page"
          />
        )}
        </Box>
      ),
      filterVariant: "multi-select",
      filterSelectOptions: ["To Do", "In Progress", "Done"],
      Cell: ({ cell, row }: { cell: any; row: any }) => {
        if (row.original?.isAddRow) return null;
        const value = cell.getValue() as string;
        const canEdit = row.original?.canEdit ?? false;
        const canEditDueDate = !isReadOnly && canEdit;
        const [isStatusOpen, setStatusOpen] = useState(false);
        const isSelected = selectedActionItemIds?.includes(row.original.id);
        const appliedValue =
        isSelected && bulkUpdateValues?.status?.value
          ? bulkUpdateValues?.status.value
          : value;
        return (
          <Box
          className={`priority-cell-wrapper ${
            isStatusOpen ? "priority-cell-wrapper--active" : ""
          } ${!canEditDueDate ? "no-hover" : ""}`}
          >
            <ActionItemsStatusCell
              value={appliedValue}
              canEdit={canEditDueDate}
              isAIGenerated={row.original.is_ai_generated}
              onChange={(newStatus) =>
                rowAction.updateStatusCallback(row, newStatus)
              }
              onOpen={() => setStatusOpen(true)}
              onClose={() => setStatusOpen(false)}
            />
          </Box>
        );
      },
      muiTableBodyCellProps: () => ({
        className: "status-table-cell",
      }),
      enableColumnFilter: true,
      enableSorting: false,
      enableColumnOrdering: true,
      grow: true,
      minSize: 150,
      size: 110,
    },
    {
      accessorKey: "subscribe",
      header: "Tracking",
      enableColumnFilter: false,
      enableSorting: false,
      enableColumnOrdering: true,
      size: 100,
      grow: true,
      Cell: ({ row }: { row: any }) => {
        if (row.original?.isAddRow) return null;
        const isSubscribed = row.original?.isSubscribed;

        return (
          <Box className="subscribed-box">
            <Tooltip title={"Stop Tracking"} arrow placement="top">
              <span>
                <IconButton
                  size="small"
                  onClick={() => {
                    rowAction.handleUnsubscribe(row);
                  }}
                >
                  <img
                    src={SubscribedIcon}
                    style={{
                      width: 20,
                      height: 20,
                      opacity: isSubscribed ? 1 : 0.4,
                    }}
                  />
                </IconButton>
              </span>
            </Tooltip>
          </Box>
        );
      },
    },
    {
      accessorKey: "subscribers",
      header: "",
      Header: (
          <Box className="column-header"
          sx={{
              padding: " 1px",
              backgroundColor: openFilterColumn === "subscribers" ? "#F2F2F2" : "inherit",
            }}>
            <Typography className="cf-title" 
            sx={{
              color:
                Array.isArray(columnFilters?.subscribers) &&
                columnFilters?.subscribers.length > 0
                  ? "#6036d6"
                  : "inherit",
            }}
            >Subscribers</Typography>

          {isReadOnly ? null :(
            <ColumnFilter
              currentValue={
                Array.isArray(columnFilters?.subscribers)
                  ? columnFilters.subscribers.map((s: any) => s.id)
                  : []
              }
              onApply={(val) => {
                const arr = val as string[]; // cast to string[]
                const mapped = (arr ?? []).map((id) => {
                  const option = subscriberOptions.find((o) => o.value === id);
                  return option ? { id: option.value, entityType: option.entityType } : null;
                }).filter(Boolean);
                updateColumnFilter?.("subscribers", mapped);
              }}
              options={subscriberOptions}
              type="multi"
              showSections={{
                search: true,
                sort: false,
              }}
              columnKey="subscribers"
              onOpen={() => {rowAction?.onColumnFilterOpen?.(); setOpenFilterColumn("subscribers")}}
              onClose={() => setOpenFilterColumn(null)}
              isActive={Array.isArray(columnFilters?.subscribers) &&
                columnFilters?.subscribers.length > 0}
              parent_page="tasks_page"
              />
            )}
          </Box>
      ),
      Cell: ({ cell, row }: { cell: any; row: any }) => {
        const subscribers = cell.getValue() as any[];
        const canEdit = row.original?.canEdit ?? false;
        const activeUsers = row.original?.activeUsers || [];
        const isSelected = selectedActionItemIds?.includes(row.original.id);
        const bulkSubscribers = isSelected ? bulkUpdateValues?.subscribe : null;
        const spacesvalues = row.original.subscribedUserGroups;
        const userSubscribers =
          isSelected && bulkSubscribers && bulkSubscribers.length > 0
            ? bulkSubscribers
                .filter((sub: any) => sub.type === "user")
                .map((sub: any) => ({
                  name: sub.label,
                  email: sub.email,
                  picture: sub.pictureUrl || null,
                  type: "user" as const,
                  profileOrgRelationshipId: sub.porId,
                }))
            : (subscribers || [])
                .filter((s) => s.email) // everything with email is user
                .map((s) => ({
                  name: s.name,
                  email: s.email,
                  picture: s.picture || s.pictureUrl || null,
                  type: "user" as const,
                  profileOrgRelationshipId: s.porId,
                }));
        const spaceSubscribers =
          isSelected && bulkSubscribers && bulkSubscribers.length > 0
            ? bulkSubscribers
                .filter((sub: any) => sub.type === "space")
                .map((sub: any) => ({
                  name: sub.label,
                  id: sub.value,
                  type: "space" as const,
                }))
            : (spacesvalues || [])
            .filter((s: any) => s.id)
              .map((s: any) => ({
                name: s.name,
                id: s.id,
                type: "space" as const,
              }));
        const spacesList = row.original.spacesList || [];
        const subscribersToUse = [...userSubscribers, ...spaceSubscribers];
        if (row.original?.isAddRow) return null;
        return (
          <SubscribersHoverPopperWrapper
            subscribers={subscribersToUse}
            userSubscribers={userSubscribers}
            spaceSubscribers={spaceSubscribers}
          >
            {(_isDropdownOpen, setIsDropdownOpen, disableTooltip) => (
              <ActionItemsSubscribersCell
                selectedSubscribers={subscribersToUse}
                attendeeParticipants={activeUsers}
                canEdit={ isReadOnly ? false : canEdit}
                row={row}
                rowAction={rowAction}
                spacesList={spacesList}
                onOpen={() => setIsDropdownOpen(true)}
                onClose={() => setIsDropdownOpen(false)}
                disableTooltip={disableTooltip}
              />
            )}
          </SubscribersHoverPopperWrapper>
        )

      },
      muiTableBodyCellProps: () => ({
        className: "assignee-table-cell",
      }),
      enableColumnFilter: false,
      enableSorting: false,
      enableColumnOrdering: true,
      grow: true,
      minSize: 120,
      size: 130,
    },
  ];

  if (!showActionsColumn) {
    return columns.filter((column) => column.accessorKey !== "actions");
  }

  return columns;
};

export { getColumns, initialSort, initialFilter };
